import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PHRASE_TYPES, useDeleteConversationPhrase } from '@/entities/conversations';
import { ConfirmationButton } from '@/shared/ui';
import { useTranscriptEditorContext } from './TranscriptEditorContext';
import type { EditableTranscriptRecord } from './types';

type Props = {
  record: EditableTranscriptRecord;
  disabled: boolean;
};

/**
 * Удаление записи с подтверждением. Подтверждение удаления реплики предупреждает о перебиваниях,
 * которые уйдут вместе с ней.
 */
export const TranscriptDeleteRecordButton: FC<Props> = ({ record, disabled }) => {
  const { t } = useTranslation(['dialogs']);
  const { conversationId, interruptionCountByPhraseId } = useTranscriptEditorContext();
  const { mutateAsync: deletePhrase, isPending } = useDeleteConversationPhrase();

  const interruptionCount = record.type === PHRASE_TYPES.PHRASE ? (interruptionCountByPhraseId.get(record.id) ?? 0) : 0;

  return (
    <ConfirmationButton
      label={t(`dialogs:transcriptEdit.deleteRecord.${record.type}`)}
      title={t(`dialogs:transcriptEdit.deleteTitle.${record.type}`)}
      description={
        interruptionCount > 0
          ? t('dialogs:transcriptEdit.deletePhraseWithInterruptions', { count: interruptionCount })
          : t('dialogs:transcriptEdit.deleteDescription')
      }
      isLoadingConfirm={isPending}
      trigger={{ size: 'icon', disabled }}
      onConfirm={() => deletePhrase({ conversationId, phraseId: record.id })}
    />
  );
};
